<template>
    <section class="hero is-fullheight">
        <div class="hero-head">
            <commemoria-navbar></commemoria-navbar>
            <div class="container is-fluid">
                <header class="level" style="margin-top: 15px; margin-bottom: 15px;">
                    <div class="level-left">
                        <div class="level-item">
                            <p class="title" style="font-size: 1.5rem;">
                                {{ event.title }}
                            </p>
                        </div>
                    </div>


                </header>
                <div class="level">
                    <!-- Left side -->
                    <div class="level-left">
                        <div class="level-item" style="min-width: 250px; justify-content: left;">
                            <p class="is-italic" style="font-size: 1rem; opacity: 0.7;">
                                <i class="fa fa-calendar" aria-hidden="true" style="padding-right: 0.5rem;"></i>
                                <span>{{ format_date(event.start) }}</span>
                                <span v-if="event.end"> &mdash; </span>
                                <span v-if="event.end">{{ format_date(event.end) }}</span>
                            </p>
                        </div>
                        <div class="level-item" style="min-width: 250px; justify-content: left;">
                            <p class="is-italic" style="font-size: 1rem; opacity: 0.7;">
                                <i class="fa fa-user" aria-hidden="true" style="padding-right: 0.5rem;"></i>
                                <span>{{ event.author.name }}</span>
                            </p>
                        </div>
                        <div class="level-item">
                            <p>
                                <b-tag type="is-dark" v-if="event.status == 'draft'">
                                    <span class="is-uppercase">brouillon</span>
                                </b-tag>
                            </p>
                        </div>
                    </div>

                    <!-- Right side -->
                    <div class="level-right">
                        <div class="level-item">
                            <div class="buttons" style="gap: 0.2rem;">
                                <b-tooltip label="Evénement précédent" type="is-dark" position="is-bottom">
                                    <button class="button is-light" @click="goToPreviousEvent" :disabled="!navigation.previous.id">
                                        <span class="icon is-small">
                                            <i class="fa fa-angle-left fa-lg" aria-hidden="true"></i>
                                        </span>
                                    </button>
                                </b-tooltip>
                            
                                <b-tooltip label="Evénement suivant" type="is-dark" position="is-bottom">
                                    <button class="button is-light" @click="goToNextEvent" :disabled="!navigation.next.id">
                                        <span class="icon is-small">
                                            <i class="fa fa-angle-right fa-lg" aria-hidden="true"></i>
                                        </span>
                                    </button>
                                </b-tooltip>
                                
                                <template v-if="policies.event.duplicate">
                                    <b-tooltip label="Dupliquer" type="is-dark" position="is-bottom">
                                        <button class="button is-light" @click="duplicate()">
                                            <span class="icon is-small">
                                                <i class="fa fa-clone fa-lg" aria-hidden="true"></i>
                                            </span>
                                        </button>
                                    </b-tooltip>
                                </template>
                        
                                <b-tooltip label="Transférer" type="is-dark" position="is-bottom">
                                    <button class="button is-light" @click="transferEventModal()">
                                        <span class="icon is-small">
                                            <i class="fa fa-exchange fa-lg" aria-hidden="true"></i>
                                        </span>
                                    </button>
                                </b-tooltip>
                        
                                <template v-if="policies.event.delete">
                                    <b-tooltip label="Supprimer" type="is-dark" position="is-bottom">
                                        <button class="button is-light" @click="confirmDestroyEvent">
                                            <span class="icon is-small">
                                                <i class="fa fa-trash-o fa-lg" aria-hidden="true"></i>
                                            </span>
                                        </button>
                                    </b-tooltip>
                                </template>
                        
                                <template v-if="policies.event.update">
                                    <b-tooltip label="Modifier" type="is-dark" position="is-bottom">
                                        <button class="button is-light" @click="editEventModal">
                                            <span class="icon is-small">
                                                <i class="fa fa-pencil fa-lg" aria-hidden="true"></i>
                                            </span>
                                        </button>
                                    </b-tooltip>
                                </template>
                            </div>
                        </div>
                        
                        <div class="level-item" v-if="policies.medias.create">
                            <b-dropdown position="is-bottom-left">
                                <button class="button is-primary" slot="trigger">
                                    <span>Ajouter des médias</span> &nbsp; <i class="fa fa-angle-down"></i>
                                </button>

                                <b-dropdown-item has-link>
                                    <a onclick="event.preventDefault();document.getElementById('files').click();" style="padding-right: 0;">
                                        Importer des médias depuis mon appareil
                                    </a>
                                </b-dropdown-item>
                                <b-dropdown-item @click="cardModal()">Importer des médias depuis internet</b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </div>
                </div>
                
                <p class="subtitle" style="font-size: 1rem;" v-show="event.description">
                    {{ event.description }}
                </p>
            </div>
        </div>
        <div class="hero-body">
            <div class="container is-fluid">
                <div v-if="!loading">
                    <input type="file" id="files" ref="files" multiple @change="handleFilesUpload()"/>
            
                    <div class="box" v-if="this.files.length > 0">
                        <div class="columns is-mobile">
                            <div class="column is-half is-offset-one-quarter">
                                <p class="has-text-centered">
                                    Chargement en cours
                                </p>
                                <br />
                                <progress class="progress" max="100" :value.prop="uploadPercentage">{{ uploadPercentage }} %</progress>
                            </div>
                        </div>
                    </div>

                    <div v-if="medias.length > 0">
                        <sortable-list v-model="medias" @sorted="reorder">
                            <div class="columns is-multiline" slot-scope="{ items }" style="outline: 0;">
                                <sortable-item v-for="media in items" :key="media.id">
                                    <div class="column is-3" style="outline: 0;">
                                        <sortable-handle>
                                            <div class="card" style="padding: 15px; cursor: grab;">
                                                <div class="card-image" @click="previewMedia(media)" style="cursor: pointer;">
                                                    <figure class="image is-1by1">
                                                        <img :src="'https://img.youtube.com/vi/'+media.filename+'/0.jpg'" v-if="media.type == 'video/youtube'" />
                                                        <img class="pr1" :style="'background-image: url('+media.thumbnail+')'" v-else-if="media.thumbnail" />
                                                        <img src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgaGVpZ2h0PSIzMnB4IiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAzMiAzMiIgd2lkdGg9IjMycHgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6c2tldGNoPSJodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2gvbnMiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48dGl0bGUvPjxkZXNjLz48ZGVmcy8+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSI+PGcgZmlsbD0iIzkyOTI5MiIgaWQ9Imljb24tNTQtZG9jdW1lbnQiPjxwYXRoIGQ9Ik0xOS41LDMgTDkuMDAyNzYwMTMsMyBDNy44OTY2NjYyNSwzIDcsMy44OTgzMzgzMiA3LDUuMDA3MzI5OTQgTDcsMjcuOTkyNjcwMSBDNywyOS4xMDEyODc4IDcuODkwOTI1MzksMzAgOC45OTc0MjE5MSwzMCBMMjQuMDAyNTc4MSwzMCBDMjUuMTA1NzIzOCwzMCAyNiwyOS4xMDE3ODc2IDI2LDI4LjAwOTIwNDkgTDI2LDEwLjUgTDI2LDEwIEwyMCwzIEwxOS41LDMgTDE5LjUsMyBMMTkuNSwzIFogTTE5LDQgTDguOTk1NTc3NSw0IEM4LjQ0NTczNTIzLDQgOCw0LjQ1NTI2Mjg4IDgsNC45OTU0NTcwMyBMOCwyOC4wMDQ1NDMgQzgsMjguNTU0MzE4NyA4LjQ1NDcwODkzLDI5IDguOTk5OTYwMiwyOSBMMjQuMDAwMDM5OCwyOSBDMjQuNTUyMzAyNiwyOSAyNSwyOC41NTUwNTM3IDI1LDI4LjAwNjYwMjMgTDI1LDExIEwyMC45OTc5MTMxLDExIEMxOS44OTQ0OTYyLDExIDE5LDEwLjExMzQ0NTIgMTksOC45OTQwODA5NSBMMTksNCBMMTksNCBaIE0yMCw0LjUgTDIwLDguOTkxMjE1MjMgQzIwLDkuNTQ4MzUxNjcgMjAuNDUwNjUxMSwxMCAyMC45OTY3Mzg4LDEwIEwyNC42OTk5NTEyLDEwIEwyMCw0LjUgTDIwLDQuNSBaIiBpZD0iZG9jdW1lbnQiLz48L2c+PC9nPjwvc3ZnPg==" style="width: 50%; margin: auto;" v-else />
                                                    </figure>
                                                </div>
                                                <div class="card-content">
                                                    <div class="columns">
                                                        <div class="column is-11" style="padding: 10px 0 0 0; font-size: 80%;">
                                                            {{ media.name }}
                                                        </div>
                                                        <div class="column has-text-centered" style="padding: 10px 0 0 0;">
                                                            <b-dropdown position="is-bottom-left" style="cursor: pointer;">
                                                                <i class="fa fa-ellipsis-h" slot="trigger"></i>
                                                                <b-dropdown-item @click="renameMediaModal(media)">Renommer</b-dropdown-item>
                                                                <b-dropdown-item has-link>
                                                                     <a :href="media.url" class="dropdown-item" download v-if="downloadable(media)">Télécharger</a>
                                                                 </b-dropdown-item>
                                                                <b-dropdown-item @click="destroyMedia(media)">Supprimer</b-dropdown-item>
                                                            </b-dropdown>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </sortable-handle>
                                    </div>
                                </sortable-item>
                            </div>
                        </sortable-list>
                    </div>                          
                    <p class="has-text-centered" v-else>
                        Il n'y aucun document pour cet événement
                    </p>

                    <b-modal :active.sync="modal.active">
                        <div class="image" v-if="media.type.split('/', 1) == 'image'">
                            <img :src="media.url" style="overflow: hidden; max-width: 95vw; max-height: 95vh;">
                        </div>
                        <div class="youtube" v-else-if="media.type == 'video/youtube'">
                            <youtube :video-id="media.filename" ref="youtube" :width="960" :height="540"></youtube>
                        </div>

                        <div class="video" v-else-if="media.type == 'video/mp4'">
                            <video-player class="vjs-custom-skin" ref="videoPlayer" :options="playerOptions()"></video-player>
                        </div>

                        <div class="pdf" v-else-if="media.type == 'application/pdf'">
                            <pdf :source="media.url" :controls="['rotate',
'zoom','catalog','switchPage']" :settings="{ defaultZoom: 200 }" loading-text="Chargement en cours" rendering-text="Chargement en cours" style="height: 90vh;"/>
                        </div>

                        <div class="has-text-centered has-text-white" v-else>
                            Ce type de document ne peut être visualisé.
                            <br />
                            <br />
                            <a :href="media.url" download class="button is-primary">
                                Télécharger
                            </a>
                        </div>
                    </b-modal>
                </div>
            </div>
        </div>
        <div class="hero-foot">
            <commemoria-footer></commemoria-footer>
        </div>
        <b-loading :active.sync="loading"></b-loading>
    </section>
</template>

<script>
    export default {

        data() {
            return {
                modal: {
                    active: false,
                    content: ''
                },
                loading: true,
                event: {
                    timeline: {
                        id: null,
                        name: '',
                    },
                    author: {
                        name: ''
                    },
                },
                medias: [],
                navigation: {
                    previous: {
                        id: null
                    },
                    next: {
                        id: null
                    }
                },
                policies: {
                    event: {},
                    medias: {}
                },
                files: [],
                uploadPercentage: 0,
                media: {
                    id: '',
                    name: '',
                    type: '',
                    url: ''
                },
            }
        },

        methods: {
            handleFilesUpload() {
                this.files = this.$refs.files.files;
                this.submitFiles();
            },

            ThumbnailLoadError(media) {
                alert('error');
            },

            submitFiles() {
                new Promise(resolve => setTimeout(resolve, 5000));

                let formData = new FormData();

                formData.append('model', 'event');
                formData.append('model_id', this.event.id);

                for (var i = 0; i < this.files.length; i++){
                    let file = this.files[i];

                    formData.append('files['+ i + ']', file);
                }

                axios.post( '/api/v1/medias', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    onUploadProgress: progressEvent => {
                        this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total ) );
                    }
                }).then( response => {
                    this.$buefy.toast.open({
                        message: 'Vos fichiers ont été ajoutés.',
                        type: 'is-success'
                    });

                    this.files = '';

                    this.fetchData(this.event.id);
                    
                }).catch( response => {
                    this.$buefy.toast.open({
                        message: 'Une erreur s\'est produite',
                        type: 'is-danger'
                    });
                });
            },

            fetchEvent(id) {
                return axios.get('/api/v1/events/'+id)
                    .then(response => {
                        this.event = response.data.event;
                        this.policies.event = response.data.policies;
                        this.navigation = response.data.navigation;
                    }).catch(response => {
                    this.$buefy.toast.open({
                        message: 'Une erreur s\'est produite',
                        type: 'is-danger'
                    });
                });
            },

            fetchMedias(id) {
                return axios.get('/api/v1/events/'+id+'/medias')
                .then(response => {
                    this.medias = response.data.medias;
                    this.policies.medias = response.data.policies;
                })
                .catch(response => {
                    this.$buefy.toast.open({
                        message: 'Une erreur s\'est produite',
                        type: 'is-danger'
                    });
                });
            },

            fetchData(id) {
                this.loading = true;

                Promise.all([this.fetchEvent(id), this.fetchMedias(id)])
                .finally(values => {
                    this.loading = false;
                });
            },

            reorder(medias) {
                var data = _.map(medias, 'id');

                axios.post('/api/v1/events/' + this.$route.params.id + '/medias/reorder', data).then(response => {
                    this.$buefy.toast.open({
                        message: 'L\'ordre des médias a été modifié',
                        type: 'is-success'
                    });
                });;
            },

            duplicate() {
                this.loading = true;

                axios.post('/api/v1/events/' + this.event.id + '/duplicate')
                .then(response => {
                    this.$buefy.toast.open({
                        message: 'L\'événement a été dupliqué',
                        type: 'is-success'
                    });

                    this.loading = false;

                }).catch(error => {
                    this.$buefy.toast.open({
                        message: 'Une erreur s\'est produite',
                        type: 'is-danger'
                    });

                    this.loading = false;
                });
            },

            editEventModal() {
                this.$buefy.modal.open({
                    parent: this,
                    component: require('../../modals/editEvent').default,
                    props: {
                        event: this.event,
                    },
                    hasModalCard: true
                });
            },

            transferEventModal() {
                this.$buefy.modal.open({
                    parent: this,
                    component: require('../../modals/transferEvent').default,
                    props: {
                        event: this.event,
                        isCopyMandatory: ! this.policies.event.delete,
                    },
                    hasModalCard: true
                });
            },

            renameMediaModal(media) {
                this.media = media,

                this.$buefy.modal.open({
                    parent: this,
                    component: require('../../modals/renameMedia').default,
                    hasModalCard: true,
                    props: {
                        media: this.media,
                    }
                });
            },

            cardModal() {
                this.$buefy.modal.open({
                    parent: this,
                    component: require('../../modals/importMediaURL').default,
                    hasModalCard: true
                });
            },

            previewMedia(media) {
                this.media = media;
                this.modal.active = true;
            },

            downloadable(media) {

                if (media.type == 'video/youtube') {
                    return false;
                }

                return true;
            },

            goToPreviousEvent() {
                this.$router.push({ name: 'events.show', params: {id: this.navigation.previous.id}});
            },

            goToNextEvent() {
                this.$router.push({ name: 'events.show', params: {id: this.navigation.next.id}});
            },

            playerOptions() {
                return {
                    height: '360',
                    sources: [{
                        type: "video/mp4",
                        src: this.media.url
                    }],
                }
            },

            confirmDestroyEvent() {
                this.$buefy.dialog.confirm({
                    title: 'Supprimer l\'événement',
                    message: 'Êtes-vous certain de vouloir <b>supprimer</b> cet événement ? <br />Cette action ne peut pas être annulée.',
                    confirmText: 'Supprimer l\'événement',
                    cancelText: 'Annuler',
                    type: 'is-danger',
                    hasIcon: false,
                    onConfirm: () => this.destroyEvent()
                })
            },

            destroyEvent() {
                axios.delete('/api/v1/events/'+this.$route.params.id)
                .then( response => {
                    this.$router.push({ name: 'timelines.show', params: {id: this.event.timeline.id}});

                    this.$buefy.toast.open({
                        message: 'L\'événement a été supprimé',
                        type: 'is-success'
                    });
                }).catch(response => {
                    this.$buefy.toast.open({
                        message: 'Une erreur s\'est produite',
                        type: 'is-danger'
                    });
                });
            },

            destroyMedia(media) {
                axios.delete('/api/v1/medias/'+media.id)
                .then( response => {
                        this.$buefy.toast.open({
                            message: 'Le document a été supprimé',
                            type: 'is-success'
                        });

                        this.fetchData(this.$route.params.id);

                }).catch(response => {
                    this.$buefy.toast.open({
                        message: 'Une erreur s\'est produite',
                        type: 'is-danger'
                    });
                });
            }
        },

        created() {
            this.fetchData(this.$route.params.id);

            Bus.$on('event.fetch', () => this.fetchData(this.$route.params.id));
        },

        destroyed() {
            Bus.$off('event.fetch');
        },

        beforeRouteUpdate (to, from, next) {
            this.fetchData(to.params.id);

            next();
        },

        breadcrumb() {
            return {
                label: this.event.title,
                parentsList: [
                    {
                        to: {
                            name: 'timelines.show',
                            params: {
                                id: this.event.timeline.id
                            }
                        },
                        label: this.event.timeline.title
                    },
                    {
                        to: '/',
                        label: 'Commemoria'
                    }
                ]
            }
        }
    }
</script>

<style scoped>
    .buttons .button, .buttons:last-child {
        margin-bottom: 0;
    }

    #files {
        width: 0;
        height: 0;
        opacity: 0;
    }

    .pr1 {
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
    }

    .tag:not(body).is-dark {
        background-color: #b5b5b5;
        color: white;
    }
</style>